import { Component, inject, OnInit, signal } from '@angular/core';
import { TenantDashboardService, TenantDashboardSummary } from '../../../shared/services/tenant-dashboard.service';
import { TenantAuthService } from '../../../services/tenant-auth.service';
import { AdminPageHeaderComponent } from '../../../shared/admin';

@Component({
  selector: 'app-tenant-dashboard-page',
  standalone: true,
  imports: [AdminPageHeaderComponent],
  template: `
    <section>
      <app-admin-page-header>
        <p description class="cg-form-help">{{ franchiseName() }}</p>
      </app-admin-page-header>

      @if (summary(); as s) {
        <div class="cg-admin-form-grid cg-admin-form-grid--3">
          <div class="cg-admin-stat-card">
            <p class="cg-form-help">Staff</p>
            <p class="text-2xl font-semibold">{{ s.usersCount }}</p>
          </div>
          <div class="cg-admin-stat-card">
            <p class="cg-form-help">Leads</p>
            <p class="text-2xl font-semibold">{{ s.leadsCount }}</p>
          </div>
          <div class="cg-admin-stat-card">
            <p class="cg-form-help">Active counselors</p>
            <p class="text-2xl font-semibold">{{ s.activeCounselors }}</p>
          </div>
        </div>
      }
    </section>
  `,
})
export class TenantDashboardPageComponent implements OnInit {
  private readonly dashboardService = inject(TenantDashboardService);
  private readonly tenantAuth = inject(TenantAuthService);

  readonly summary = signal<TenantDashboardSummary | null>(null);
  readonly franchiseName = () => this.tenantAuth.currentUser()?.franchise?.name ?? '';

  ngOnInit(): void {
    this.dashboardService.getSummary().subscribe({
      next: (data) => this.summary.set(data),
    });
  }
}
